import { getPublicToken } from 'components/QueryPerimeter/hooks/useGetTreeData';
import { useLocation, useParams } from 'react-router-dom';
import { useChartMetadataContext } from 'routes/Explore/components/Contexts/ChartMetadataContext/ChartMetadataContext';
import { getSlugFromDashboardSearchParams } from 'routes/Explore/helpers';
import useGetDashboard from 'routes/Explore/hooks/useGetDashboard';

export const useGetDashboardFromSlugOrMetadata = () => {
    const publicToken = getPublicToken();
    const chartMetadata = useChartMetadataContext();
    const { search } = useLocation();
    const { slug: slugParam } = useParams();
    const slug = getSlugFromDashboardSearchParams(search);

    const { data: dashboard } = useGetDashboard(slugParam || slug, publicToken);

    if (chartMetadata) return chartMetadata.dashboard;

    if (slug || slugParam) {
        return dashboard;
    }

    return undefined;
};
